<template>
	<div>
		<el-form size="mini" :inline="true" class="demo-form-inline">
			<el-form-item label="账单生成时间">
				<el-date-picker
					v-model="value"
					type="daterange"
					align="right"
					unlink-panels
					placeholder="选择日期"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:clearable="clearable"
					:picker-options="pickerOptions">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="学校" prop="schoolId" v-if="$store.getters.type != 1">
				<el-select v-model="queryForm.schoolId" filterable clearable placeholder="请选择">
					<el-option
						v-for="item in schoolOptions"
						:key="item.school_id"
						:label="item.school_name"
						:value="item.school_id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSearch">查询</el-button>
				<el-button @click="resetForm">重置</el-button>
			</el-form-item>
		</el-form>
		<div class="line"></div>
		<el-row class="pb10">
			<el-button type="primary" size="mini" @click="printPDF">打印</el-button>
		</el-row>
		<el-card class="box-card mb20" style="background-color: #eaf5fc">
			<el-row>
				<el-col :span="6">
					<p>订单数量总计</p>
					<p class="red mt10">{{summary.orderCount}}单</p>
				</el-col>
				<el-col :span="6">
					<p>退单数量总计</p>
					<p class="red mt10">{{summary.refundCount}}单</p>
				</el-col>
				<el-col :span="6">
					<p>配送费总计</p>
					<p class="red mt10">{{summary.deliveryFeeTotalAmount}}元</p>
				</el-col>
				<el-col :span="6">
					<p>应付款项</p>
					<p class="red mt10">{{summary.payTotalAmount}}元</p>
				</el-col>
			</el-row>
		</el-card>
		<el-row class="pb10">
			<export-excel :params="exportParams" :action="$apiUrl.financeSchoolBill" :target="'finance'" :field="field" :filename="fileName" :fieldname="fieldName" method="post"></export-excel>
			<!--<el-button class="fr" type="primary" size="mini" @click="printPDF">打印</el-button>-->
			<p class="primary f12 pt10">应付款项：包含加价、佣金、配送费、环保费、服务费</p>
		</el-row>
		<el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="scheduleBillCode"
                    label="账单编号"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="checkoutCommercialName"
                    label="商户名称"
                    :show-overflow-tooltip="true"
                    width="140">
            </el-table-column>
            <el-table-column
                    prop="expectPayDate"
                    label="生成时间"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="startDate"
                    label="开始时间"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="endDate"
                    label="结束时间"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="orderSum"
                    label="订单数量"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="refundSum"
                    label="退单数量"
                    width="100">
            </el-table-column>
            <!--<el-table-column-->
                    <!--prop="billStatusStr"-->
                    <!--label="成本价"-->
                    <!--width="120">-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
                    <!--prop="actualPayDate"-->
                    <!--label="加价"-->
					<!--width="120">-->
            <!--</el-table-column>-->
			<!--<el-table-column-->
					<!--prop="actualPayDate"-->
					<!--label="佣金"-->
					<!--width="120">-->
			<!--</el-table-column>-->
			<el-table-column
					prop="deliveryFee"
					label="配送费"
					width="100">
			</el-table-column>
			<el-table-column
					prop="serviceFee"
					label="服务费"
					width="120">
			</el-table-column>
			<el-table-column
					prop="billAmount"
					label="应付款项"
					width="100">
			</el-table-column>
			<el-table-column
					prop="billStatus"
					label="状态"
					width="">
				<template slot-scope="scope">
					<span v-if="scope.row.billStatus == 0">未打款</span>
					<span v-if="scope.row.billStatus == 1">调起自动付款</span>
					<span v-if="scope.row.billStatus == 2">付款成功</span>
					<span v-if="scope.row.billStatus == 3">付款失败</span>
					<span v-if="scope.row.billStatus == 8">无需打款</span>
					<span v-if="scope.row.billStatus == 9">冻结</span>
				</template>
			</el-table-column>
            <!--<el-table-column-->
                    <!--prop=""-->
                    <!--label="操作"-->
                    <!--fixed="right"-->
                    <!--width="200"-->
                    <!--header-align="center"-->
                    <!--align="center">-->
                    <!--<template slot-scope="scope">-->
                    	<!--<el-button type="text" @click="exportExcel(scope.$index)">导出明细</el-button>-->
	                <!--</template>    -->
            <!--</el-table-column>-->
        </el-table>
	</div>
</template>

<script>
	import moment from 'moment';
	import ExportExcel from "../../components/exportExcel2.vue";
	export default {
		components: {ExportExcel},
		data () {
			return {
				 pickerOptions: {
		          disabledDate(time) {
		            return time.getTime() > Date.now();
		          },
		          shortcuts: [{
		            text: '最近一周',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近一个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近三个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
		              picker.$emit('pick', [start, end]);
		          	}
		          }],
		        },
		        value: [],
		        queryForm: {
                    pageSize: 9999,
                    pageNo: 1,
					schoolId: '',
					for_report: true
                },
		        loading: false,
                clearable: false,
                tableData: [],
				schoolOptions: [],
				summary: {},

				//导出
				exportParams: {},
				fileName: '校园卡应付账单表',
				fieldName: ['账单编号','商户名称','生成时间','开始时间','结束时间','订单数量','退单数量','配送费','服务费','应付款项','状态'],
				field: ['scheduleBillCode','checkoutCommercialName','expectPayDate','startDate','endDate','orderSum','refundSum','deliveryFee','serviceFee','billAmount','billStatus']
		    }
		},
        created(){
			if(this.$store.getters.type == 2){
				this.getSchools();
			}else{
				this.queryForm.schoolId = localStorage.getItem('schoolId');
			}
            //默认显示最近一周
            if(this.$route.query.date){
                let temp = [];
                temp = this.$route.query.date.split('-');
                this.value = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
            }else{
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.value = [day,new Date()];
            }
            this.onSearch();
        },
		methods: {
			getParams() {
                let params = {...this.queryForm};
                params.startDate = moment(this.value[0]).format('YYYY-MM-DD').toString();
                params.endDate = moment(this.value[1]).format('YYYY-MM-DD').toString();

				this.exportParams = {...params};
				this.exportParams.pageNo = 1;
				this.exportParams.pageSize = 99999;

                return params;
            },
			onSearch() {
				if(this.value.length > 0) {
					let params = this.getParams();
					this.$apiJava.post(this.$apiUrl.financeSchoolBill,params,(res)=>{
						this.loading = false;
                    	this.tableData = res.data.list || [];
					},(res)=>{
						this.$message.warning(res.message);
						this.loading = false;
						this.tableData = [];
					},'finance')
					this.$apiJava.post(this.$apiUrl.financeSchoolBillSummary,params,(res)=>{
						this.summary = res.data;
					},(res)=>{
						this.$message.warning(res.message);
					},'finance')
				} else {
					this.$message.error('请选择正确日期');
				}
			},
			resetForm() {
                this.value = [];
                this.tableData = [];
                this.queryForm.schoolId = '';
            },
            getSchools() {
				let params = {
					account_id: this.$store.getters.userId
				}
				this.$api.post(this.$apiUrl.schoolInCommercial,params,(res)=>{
					this.schoolOptions = res.data;
				},(res)=>{
					this.$message.warning(res.message);
				})
			},
			printPDF() {
				let hostStr = window.location.host;
				let host = hostStr.replace('e','oc');
				let url = location.protocol +'//'+ host + '/' + this.$apiUrl.schoolCompanyExportPDF + '?export=1&startDate=' + moment(this.value[0]).format('YYYY-MM-DD').toString() + '&endDate=' + moment(this.value[1]).format('YYYY-MM-DD').toString() + '&schoolId=' + this.queryForm.schoolId;
				window.open(url);
			}
		}
	}
</script>

<style lang="scss"  scoped>
	.el-card{
		border: none;
		box-shadow: none;
	}
</style>


// WEBPACK FOOTER //
// schoolBill.vue?af9bbe3a